import axios from "axios";
import { attachHttpLogging } from "../utils/logging/attachHttpLogging";

const BASE_URL = (process.env.NEXT_PUBLIC_BASE_URL as string | undefined) || "/api";

const publicApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

publicApi.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === "production") {
      config.headers = config.headers ?? {};
      config.headers["X-Internal-Request"] = "yes";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Attach unified HTTP error logging
attachHttpLogging(publicApi, "publicApi");

// For quick debugging (browser only)
if (typeof window !== "undefined") {
  // @ts-ignore
  window.publicApi = publicApi;
}

export default publicApi;
